import type {
  CanonicalPsrParamsType,
  CanonicalPsrReturnType
} from './psr-types';

export const canonicalPsr = ({
  parentCode,
  code,
  displayName,
  description,
  requiresExpiryDate
}: CanonicalPsrParamsType): CanonicalPsrReturnType => {
  return {
    code: parentCode || code,
    requiresExpiryDate,
    description,
    displayName,
    ...(parentCode &&
      code && {
        subCode: code
      })
  };
};
